import * as React from "react";
import Box from "@mui/material/Box";
//import Toolbar from "@mui/material/Toolbar";
//import { Theme } from "../Styles/styles";
//import { ThemeProvider } from "@mui/material/styles";
//import Typography from "@mui/material/Typography";
import { LicenseListItem } from "../Atoms/LicenseListItem";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { TitleAction } from "../Atoms/TitleAction";
import { Modal } from "@mui/material";
import { withCreateLicenseClassItem } from "./withCreateLicenseClassItem";
import { format } from 'date-fns';


interface LicenseClassItem {
  id: number;
  insertedDateTime: Date;
  updatedDateTime: Date;
  description: string;
  isActive: boolean;
}

const apiUrl = localStorage.getItem("apiUrl");
//const token = process.env.REACT_APP_API_FAKE_TOKEN;



export const LicenseClassManager = () => {

  const token: string | any = localStorage.getItem("idToken");

  const [isAddLicenseClassModalOpen, setIsAddLicenseClassModalOpen] =
    React.useState(false);

  const handleCloseAddLicenseClassModal = () =>
    setIsAddLicenseClassModalOpen(false);
  const handleOpenAddLicenseClassModal = () =>
    setIsAddLicenseClassModalOpen(true);

  const getLicenseClasses = async () => {

    const response = await axios.get(
      `${apiUrl}/api/v1/licenceClass`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const resp = response.data;
    return resp;
  };


  const { isLoading, isError, data, error, isSuccess } = useQuery({
    queryKey: ["licenseClasses"],
    queryFn: getLicenseClasses,
  });

  if (isLoading) {
    return <span>Loading...</span>;
  }

  if (isError) {
    alert(`Wystąpił błąd aplikacji. Szczegóły: ${error.message}`);
    return <span>Error: {error.message}</span>;
  }

  const AddLicenseClassForm = withCreateLicenseClassItem({
    apiUrl: apiUrl,
    token: token,
    onCloseButton: handleCloseAddLicenseClassModal,
    getLicenseClasses: getLicenseClasses,
  });

  return (

    <Box

      sx={{
        display: "flex",
        flexDirection: "column",
        //flexGrow: 1,
        gap: 1,
        p: 3,
        minWidth: "1000px",
      }}
    >
      <TitleAction
        actionName="Dodaj klasę"
        title="Lista klas licencji"
        actionClickHandler={handleOpenAddLicenseClassModal}
      />
      {data?.map((el: LicenseClassItem, index: number) => (
        <LicenseListItem
          key={index}
          isProfile={false}
          licenceClassId={el?.id}
          licenceClassDescriptio={el?.description}
          deviceProfileId={format(el?.insertedDateTime, 'd/MM/yyyy k:mm')}
          deviceProfileName={format(el?.updatedDateTime, 'd/MM/yyyy k:mm')}
          isActive={el?.isActive}
          showvertIcon={true}
        />
      ))}

      <Modal
        open={isAddLicenseClassModalOpen}
        onClose={handleCloseAddLicenseClassModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            position: "absolute",
          }}
        >
          <AddLicenseClassForm />
        </Box>
      </Modal>
    </Box>

  );
};
